import { useEffect, useRef, useState } from 'react';

export interface IDisposable {
  dispose(): void;
}
export function useAsyncDisposable<AsyncDisposable extends IDisposable>(fn: () => Promise<AsyncDisposable>) {
  const [workerState, setWorkerState] = useState<AsyncDisposable | null>(null);
  const ref = useRef<Promise<AsyncDisposable>>();
  useEffect(() => {
    ref.current = fn();
    ref.current?.then((worker) => {
      setWorkerState(worker);
    });
    return () => {
      ref.current?.then((worker) => worker.dispose());
    };
  }, []);

  return workerState;
}
